import {
  HeartPulse,
  Landmark,
  Layers,
  Lightbulb,
  RadioTower,
  ShoppingBag,
} from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const INDUSTRIES = [
  { icon: HeartPulse, label: "Healthcare" },
  { icon: RadioTower, label: "Telecom" },
  { icon: Landmark, label: "BFSI" },
  { icon: ShoppingBag, label: "E-Commerce" },
  { icon: Layers, label: "SaaS & Digital Products" },
  { icon: Lightbulb, label: "Startups" },
];

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="border-y border-navy/10 bg-sage/30 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Eyebrow>Industries</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            Industry experience
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-navy/70">
            Requirements and product work across domains where business rules,
            workflows and compliance matter.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.label} delay={i * 0.05}>
              <div
                data-testid={`industry-tile-${i}`}
                className="flex h-full flex-col gap-5 border border-navy/15 bg-cream p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-navy/40"
              >
                <ind.icon className="h-6 w-6 text-rust" strokeWidth={1.5} />
                <p className="text-sm font-semibold leading-snug tracking-tight">
                  {ind.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
